<template>
  <div class="examArrangement">
    <div v-if="activeMenu == 'examArrangement'">
      <el-row class="tableHearInputBox" type="flex" justify="end">
        <el-col >
          <el-input
              v-model.trim="query.query"
              placeholder="请输入考试科目"
              style="width: 220px"
              @keyup.enter.native="tableLoad"
              @clear="
              query.query = '';
              query.pageNum=1;
              tableLoad();
            "
              clearable
              suffix-icon="el-icon-search"
          ></el-input>
          <Debounce>
            <el-button style="margin:0px 10px" size="small" @click="query.pageNum=1;
              tableLoad();"
            >查询</el-button
            >
          </Debounce>
          <el-select v-model="query.applicationYear" @change="tableLoad" filterable placeholder="请选择">
            <el-option label="全部年份" value= ""></el-option>
            <el-option v-for="item in yearSelectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select style="margin-left: 10px;width: 160px" v-model="query.hasLock" @change="tableLoad" filterable placeholder="请选择">
            <el-option label="全部科目状态" value= ""></el-option>
            <el-option label="科目状态（正常）" :value= "0"></el-option>
            <el-option label="科目状态（锁定）" :value= "1"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;" :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中" :height="$store.getters.getTableHeight">
        <el-table-column prop="subjectName" label="考试科目" align="center"></el-table-column>
        <el-table-column label="考试年份"  align="center">
          <template slot-scope="scope">
            {{ scope.row.examYear }}年
          </template>
        </el-table-column>
        <el-table-column prop="kspc" label="考试批次" align="center">
        <template slot-scope="scope">
          {{ scope.row.kspc === 1 ? "春季" : scope.row.kspc === 2 ? "夏季": scope.row.kspc === 3 ? "秋季" : scope.row.kspc === 4 ? "冬季":''}}
        </template>

      </el-table-column>
        <el-table-column label="预计考试时间" width="350px" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime }}-
            {{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column prop="unArrangeNum" label="待安排人数" align="center"></el-table-column>
        <el-table-column prop="arrangeNum" label="已安排人数" align="center"></el-table-column>
        <el-table-column label="考场安排" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="goTo(scope.row)">考场详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content" @pagination="tableLoad" />
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import NotScheduled from './notScheduled'
import Scheduled from './scheduled'

export default {
  name: "examArrangement",
  components:{
    NotScheduled,
    Scheduled,
  },
  data(){
    return{
      activeName:'notScheduled',
      tableList: [],
      yearSelectList:[],
      tableIsLoad: false,
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        applicationYear:'',
        hasLock:0,
      },
    }
  },
  async mounted() {
    await this.getAllSelectList()
    await this.tableLoad()
  },
  computed: {
    activeMenu() {
      return this.$route.name;
    },
  },
  methods:{
    goTo(row) {
      this.$router.push({
        path:'/examManag/examArrangement/examArrangementInfo',
        query:{
          id:row.examId,
        }
      });
    },
    async tableLoad() {
      this.tableIsLoad = true;
      await this.$axios.post("/arrange", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    async getAllSelectList(){
      await this.$axios.get("/examInformation/selectFilterData").then((res) => {
        const data = res.data.data;
        this.yearSelectList=data;
        this.query.applicationYear = data[0]?data[0].value:'';
      });
    },
  }
}
</script>
